import { render, staticRenderFns } from "./loginPointOfSale.vue?vue&type=template&id=8864007a&scoped=true&"
import script from "./loginPointOfSale.vue?vue&type=script&lang=js&"
export * from "./loginPointOfSale.vue?vue&type=script&lang=js&"
import style0 from "./loginPointOfSale.vue?vue&type=style&index=0&id=8864007a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8864007a",
  null
  
)

export default component.exports